import browserUpdate from 'browser-update/update.npm';

function initBrowserUpdate(browserUpdateOpts) {
    const defaultOpts = {
        required: {
            e: -3,
            f: -3,
            o: -3,
            s: -1,
            c: -3,
          },
          insecure: true,
          unsupported: true,
          text: {
            msg: 'Your web browser ({brow_name}) is out of date.',
            msgmore: 'Some features on this site may not work.',
            bupdate: 'Update browser',
            bignore: 'Ignore',
            remind: 'You will be reminded in {days} days.',
            bnever: 'Never show again',
          },
          text_for_i: {
            msg: 'Your browser, Internet Explorer, is no longer supported by Microsoft and will not work on this site.',
            msgmore: 'Update your browser as soon as possible to use this site.',
         },
          style: 'bottom',
          onshow(info) {
            console.log(`Browser ${info.browser.t} is out of date.`);
          },
          onclick(info) {
          },
          onclose(info) {
          },
    };

    browserUpdate({ ...defaultOpts, ...browserUpdateOpts });
}

export default {
    initBrowserUpdate,
};
